import { h } from "vue";
import AddIcon from "./AddIcon.vue";
import ArrowRightIcon from "./ArrowRightIcon.vue";
import BullIcon from "./BullIcon.vue";
import ChevronDownIcon from "./ChevronDownIcon.vue";
import ChevronLeftIcon from "./ChevronLeftIcon.vue";
import ChevronRightIcon from "./ChevronRightIcon.vue";
import ChevronUpIcon from "./ChevronUpIcon.vue";
import CubesIcon from "./CubesIcon.vue";
import DashboardIcon from "./DashboardIcon.vue";
import SimulationIcon from "./SimulationIcon.vue";
import ExportIcon from "./ExportIcon.vue";
import HelpIcon from "./HelpIcon.vue";
import HomeIcon from "./HomeIcon.vue";
import MountainIcon from "./MountainIcon.vue";
import NewWindowIcon from "./NewWindowIcon.vue";
import OverflowMenuVerticalIcon from "./OverflowMenuVerticalIcon.vue";
import PencilIcon from "./PencilIcon.vue";
import SearchIcon from "./SearchIcon.vue";
import SettingIcon from "./SettingIcon.vue";
import TrashCanIcon from "./TrashCanIcon.vue";
import UploadIcon from "./UploadIcon.vue";
import UserIcon from "./UserIcon.vue";
import ViewIcon from "./ViewIcon.vue";
import ViewOffIcon from "./ViewOffIcon.vue";

const aliases = {
	Help: HelpIcon,
	User: UserIcon,
	Setting: SettingIcon,
	Mountain: MountainIcon,
	Cubes: CubesIcon,
	"Arrow-Right": ArrowRightIcon,
	"Chevron-Right": ChevronRightIcon,
	"New-Window": NewWindowIcon,
	Add: AddIcon,
	Home: HomeIcon,
	"Chevron-Left": ChevronLeftIcon,
	"Trash-Can": TrashCanIcon,
	"Chevron-Down": ChevronDownIcon,
	"Chevron-Up": ChevronUpIcon,
	"Overflow-Menu-Vertical": OverflowMenuVerticalIcon,
	Search: SearchIcon,
	View: ViewIcon,
	"View-Off": ViewOffIcon,
	Bull: BullIcon,
	Pencil: PencilIcon,
	Export: ExportIcon,
	Dashboard: DashboardIcon,
	Simulation: SimulationIcon,
	Upload: UploadIcon,
};

const custom = {
	component: (props) =>
		h(props.tag, [h(aliases[props.icon], { class: "v-icon__svg" })]),
};

export { aliases, custom };
